import { createQueryKeys } from '@lukemorales/query-key-factory';

export const installationQueryKeys = createQueryKeys('installations', {
  list: null,
});
